/**
 * @description
 * Mask user input. Replaces using a regex
 */
const removeReplace = (value: string, regex: any, replaceWith: string): string =>
  value.replace(regex, replaceWith).toLowerCase();

export default removeReplace;
